import { SideEffectSchema, loadingAction, errorAction, successSideEffectState, APIErrorResponseSchema, generateConst, V2ErrorResponseSchema } from ".";
import { CustomDomainMapping } from "../features/customDomainTemplateMapping";
export const WebAppsConst = {
  GET_WEB_APPS: "GET_WEB_APPS",
  GET_WEB_APPS_LOADING: "GET_WEB_APPS_LOADING",
  GET_WEB_APPS_SUCCESS: "GET_WEB_APPS_SUCCESS",
  GET_WEB_APPS_ERROR: "GET_WEB_APPS_ERROR",

  ADD_WEB_APPS: "ADD_WEB_APPS",
  ADD_WEB_APPS_LOADING: "ADD_WEB_APPS_LOADING",
  ADD_WEB_APPS_SUCCESS: "ADD_WEB_APPS_SUCCESS",
  ADD_WEB_APPS_ERROR: "ADD_WEB_APPS_ERROR"
};
export const CustomDomainConst = {
  GET_CUSTOM_DOMAIN: "GET_CUSTOM_DOMAIN",
  GET_CUSTOM_DOMAIN_LOADING: "GET_CUSTOM_DOMAIN_LOADING",
  GET_CUSTOM_DOMAIN_SUCCESS: "GET_CUSTOM_DOMAIN_SUCCESS",
  GET_CUSTOM_DOMAIN_ERROR: "GET_CUSTOM_DOMAIN_ERROR",
  SAVE_CUSTOM_DOMAIN: "SAVE_CUSTOM_DOMAIN",
  SAVE_CUSTOM_DOMAIN_LOADING: "SAVE_CUSTOM_DOMAIN_LOADING",
  SAVE_CUSTOM_DOMAIN_SUCCESS: "SAVE_CUSTOM_DOMAIN_SUCCESS",
  SAVE_CUSTOM_DOMAIN_ERROR: "SAVE_CUSTOM_DOMAIN_ERROR",
  DELETE_CUSTOM_DOMAIN: "DELETE_CUSTOM_DOMAIN",
  DELETE_CUSTOM_DOMAIN_LOADING: "DELETE_CUSTOM_DOMAIN_LOADING",
  DELETE_CUSTOM_DOMAIN_SUCCESS: "DELETE_CUSTOM_DOMAIN_SUCCESS",
  DELETE_CUSTOM_DOMAIN_ERROR: "DELETE_CUSTOM_DOMAIN_ERROR"
};

export interface CustomDomain {
  ID: string;
  AppID: number;
  Domain: string;
  IsDone: boolean;
  TemplateId?: string;
  StyleName?: string;
}

export interface CustomDomainSchema extends SideEffectSchema, V2ErrorResponseSchema {
  Data?: CustomDomainMapping[];
}
export interface WebAppsSchema extends SideEffectSchema {
  CallbackUrl?: string;
  DevDomain?: string;
  AppName: string;
  Key: string;
  production?: string[];
  staging?: string[];
  Secret?: string;
  errorCode?: number;
  message?: string;
  Email: string;
  ProductPlan: ProductPlan;
}
export interface ProductPlan {
  Name: string;
  DisplayName: string;
  ExpiryTime: string;
}
export const DeploymentConst = generateConst("DEPLOYMENT", [
  "GET_SMTP_SETTINGS",
  "GET_ALL_EMAIL_TEMPLATES",
  "CREATE_EMAIL_TEMPLATE",
  "UPDATE_EMAIL_TEMPLATE",
  "DELETE_EMAIL_TEMPLATE",
  "RESET_EMAIL_TEMPLATE",
  "SET_DEFAULT_EMAIL_TEMPLATE",
  "SEND_TEST_EMAIL_TEMPLATE",
  "GET_EMAIL_SETTINGS",
  "SAVE_EMAIL_SETTINGS",
  "GENERATE_EMAIL_TEMPLATE_AI",
  "RESET_EMAIL_TEMPLATE_MUTATION_STATE",
  "RESET_SEND_TEST_EMAIL_STATE",
  "RESET_GENERATE_EMAIL_TEMPLATE_AI_STATE",
  "RESET_SAVE_EMAIL_SETTINGS_STATE"
]);

export const SMTPSettingsConst = generateConst("DEPLOYMENT", ["SAVE_SMTP_SETTINGS", "VERIFY_SMTP_SETTINGS", "RESET_SMTP_SETTINGS"]);

export interface SMTPSettingSchema extends SideEffectSchema, APIErrorResponseSchema {
  FromEmailId: string;
  FromName: string;
  IsSsl: boolean;
  Password: string;
  SmtpHost: string;
  SmtpPort: number;
  UserName: string;
}

export interface SaveSMTPSettingSchema {
  FromName: string;
  FromEmailId: string;
  username?: string;
  password?: string;
  SmtpHost?: string;
  SmtpPort?: string;
  isssl?: string;
  provider?: string;
  key?: string;
  secret?: string;
}

// VERIFY SMTP SETTINGS
export interface VerifySMTPSettingSchema extends SaveSMTPSettingSchema {
  emailId: string;
  subject: string;
  message: string;
}

// export const verifySMTPSettingsAction = (settings: VerifySMTPSettingSchema, i18n: LanguageSchema) => {
//   return {
//     type: SMTPSettingsConst.VERIFY_SMTP_SETTINGS,
//     payload: settings,
//     i18n
//   };
// };
// export const verifySMTPSettingsLoadingAction = () => loadingAction(SMTPSettingsConst.VERIFY_SMTP_SETTINGS_LOADING);

// export const verifySMTPSettingsErrorAction = (error: string) => errorAction(SMTPSettingsConst.VERIFY_SMTP_SETTINGS_ERROR, error);

// export interface VerifySMTPSettingResponseSchema extends SideEffectSchema, V2ErrorResponseSchema {
//   clientIP: string;
//   isOK: boolean;
// }

// export const verifySMTPSettingsSuccessAction = (data: VerifySMTPSettingResponseSchema) => {
//   const payload: VerifySMTPSettingResponseSchema = {
//     ...data,
//     ...successSideEffectState
//   };
//   return {
//     type: SMTPSettingsConst.VERIFY_SMTP_SETTINGS_SUCCESS,
//     payload
//   };
// };

// Get Web apps
export const getWebAppsAction = (data?: any) => {
  return {
    type: WebAppsConst.GET_WEB_APPS,
    payload: { data }
  };
};
export const getWebAppsLoadingAction = () => loadingAction(WebAppsConst.GET_WEB_APPS_LOADING);

export const getWebAppsErrorAction = (error: string) => errorAction(WebAppsConst.GET_WEB_APPS_ERROR, error);

export const getWebAppsSuccessAction = (data: any) => {
  const payload: any = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: WebAppsConst.GET_WEB_APPS_SUCCESS,
    payload
  };
};

// Add Web apps

export const addWebAppsAction = (data) => {
  return {
    type: WebAppsConst.ADD_WEB_APPS,
    payload: data
  };
};

export const addWebAppsLoadingAction = () => loadingAction(WebAppsConst.ADD_WEB_APPS_LOADING);

export const addWebAppsErrorAction = (error: string) => errorAction(WebAppsConst.ADD_WEB_APPS_ERROR, error);

export const addWebAppsSuccessAction = (data: WebAppsSchema) => {
  const payload: WebAppsSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: WebAppsConst.ADD_WEB_APPS_SUCCESS,
    payload
  };
};

// Get Custom Domain

export const getCustomDomainAction = () => {
  return {
    type: CustomDomainConst.GET_CUSTOM_DOMAIN,
    payload: {}
  };
};
export const getCustomDomainLoadingAction = () => loadingAction(CustomDomainConst.GET_CUSTOM_DOMAIN_LOADING);

export const getCustomDomainErrorAction = (error: string) => errorAction(CustomDomainConst.GET_CUSTOM_DOMAIN_ERROR, error);

export const getCustomDomainSuccessAction = (data: CustomDomainSchema) => {
  const payload: CustomDomainSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: CustomDomainConst.GET_CUSTOM_DOMAIN_SUCCESS,
    payload
  };
};
/**
 * SAVE_CUSTOM_DOMAIN
 */
export interface SaveCustomDomainSchema extends SideEffectSchema, V2ErrorResponseSchema {}

export interface SaveCustomDomainArgs {
  payload: {
    CustomDomain: string;
  };
}

export const saveCustomDomainAction = (payload: SaveCustomDomainArgs) => {
  return {
    type: CustomDomainConst.SAVE_CUSTOM_DOMAIN,
    payload
  };
};

export const saveCustomDomainLoadingAction = () => loadingAction(CustomDomainConst.SAVE_CUSTOM_DOMAIN_LOADING);
export const saveCustomDomainErrorAction = (error: string) => errorAction(CustomDomainConst.SAVE_CUSTOM_DOMAIN_ERROR, error);
export const saveCustomDomainSuccessAction = (data: SaveCustomDomainSchema) => {
  const payload: SaveCustomDomainSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: CustomDomainConst.SAVE_CUSTOM_DOMAIN_SUCCESS,
    payload
  };
};

/**
 * DELETE_CUSTOM_DOMAIN
 */
export interface DeleteCustomDomainSchema extends SideEffectSchema, V2ErrorResponseSchema {}

export interface DeleteCustomDomainArgs {
  payload: {
    DomainId: string;
  };
}

export const deleteCustomDomainAction = (payload: DeleteCustomDomainArgs) => {
  return {
    type: CustomDomainConst.DELETE_CUSTOM_DOMAIN,
    payload
  };
};

export const deleteCustomDomainLoadingAction = () => loadingAction(CustomDomainConst.DELETE_CUSTOM_DOMAIN_LOADING);
export const deleteCustomDomainErrorAction = (error: string) => errorAction(CustomDomainConst.DELETE_CUSTOM_DOMAIN_ERROR, error);
export const deleteCustomDomainSuccessAction = (data: DeleteCustomDomainSchema) => {
  const payload: DeleteCustomDomainSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: CustomDomainConst.DELETE_CUSTOM_DOMAIN_SUCCESS,
    payload
  };
};

export const MobileAppsConst = {
  GET_MOBILE_APPS_SOTT: "GET_MOBILE_APPS_SOTT",
  GET_MOBILE_APPS_SOTT_LOADING: "GET_MOBILE_APPS_SOTT_LOADING",
  GET_MOBILE_APPS_SOTT_SUCCESS: "GET_MOBILE_APPS_SOTT_SUCCESS",
  GET_MOBILE_APPS_SOTT_ERROR: "GET_MOBILE_APPS_SOTT_ERROR",

  ADD_MOBILE_APPS_SOTT: "ADD_MOBILE_APPS_SOTT",
  ADD_MOBILE_APPS_SOTT_LOADING: "ADD_MOBILE_APPS_SOTT_LOADING",
  ADD_MOBILE_APPS_SOTT_SUCCESS: "ADD_MOBILE_APPS_SOTT_SUCCESS",
  ADD_MOBILE_APPS_SOTT_ERROR: "ADD_MOBILE_APPS_SOTT_ERROR"
};
export interface MobileAppsSchema extends SideEffectSchema, APIErrorResponseSchema {
  Data: AddMobileAppsSchema[];
}
export interface AddMobileAppsSchema extends SideEffectSchema {
  AuthenticityToken?: string;
  Comment?: string;
  CreatedDate?: string;
  DateRange?: string;
  IsEncoded?: boolean;
  Technology?: string;
  Sott?: string;
  errorCode?: number;
  message?: string;
  description?: string;
}
export const getMobileAppsSottAction = () => {
  return {
    type: MobileAppsConst.GET_MOBILE_APPS_SOTT,
    payload: {}
  };
};
export const getMobileAppsSottLoadingAction = () => loadingAction(MobileAppsConst.GET_MOBILE_APPS_SOTT_LOADING);

export const getMobileAppsSottErrorAction = (error: string) => errorAction(MobileAppsConst.GET_MOBILE_APPS_SOTT_ERROR, error);

export const getMobileAppsSottSuccessAction = (data: MobileAppsSchema) => {
  const payload: MobileAppsSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: MobileAppsConst.GET_MOBILE_APPS_SOTT_SUCCESS,
    payload
  };
};

export const addMobileAppsSottAction = (data) => {
  return {
    type: MobileAppsConst.ADD_MOBILE_APPS_SOTT,
    payload: data
  };
};

export const addMobileAppsSottLoadingAction = () => loadingAction(MobileAppsConst.ADD_MOBILE_APPS_SOTT_LOADING);

export const addMobileAppsSottErrorAction = (error: string) => errorAction(MobileAppsConst.ADD_MOBILE_APPS_SOTT_ERROR, error);

export const addMobileAppsSottSuccessAction = (data: AddMobileAppsSchema) => {
  const payload: AddMobileAppsSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: MobileAppsConst.ADD_MOBILE_APPS_SOTT_SUCCESS,
    payload
  };
};

export interface SettingsSchema {
  AskRequiredFieldsOnTraditionalLogin: boolean;
  IsLogoutOnEmailVerification: boolean;
  IsUserNameLogin: boolean;
  GoogleRecaptcha: boolean;
  IsV2Recaptcha: boolean;
  IsInvisibleRecaptcha: boolean;
  AskPasswordOnSocialLogin: boolean;
  AskEmailIdForUnverifiedUserLogin: boolean;
  AskOptionalFieldsOnSocialSignup: boolean;
  LoginOnEmailVerification: boolean;
}
export const JSWidgetsConst = {
  UPDATE_OPTIONAL_CAPTCHA: "UPDATE_OPTIONAL_CAPTCHA",
  UPDATE_OPTIONAL_CAPTCHA_LOADING: "UPDATE_OPTIONAL_CAPTCHA_LOADING",
  UPDATE_OPTIONAL_CAPTCHA_ERROR: "UPDATE_OPTIONAL_CAPTCHA_ERROR",
  UPDATE_OPTIONAL_CAPTCHA_SUCCESS: "UPDATE_OPTIONAL_CAPTCHA_SUCCESS"
};
export interface OptionalCaptcha extends SideEffectSchema {
  IsEnabled: boolean;
  Apis: {
    PostForgotPasswordByEmail: boolean;
    PostForgotPasswordByPhone: boolean;
    PutChangePassword: boolean;
    PostLoginByEmailAndPassword: boolean;
    PostLoginByUserNameAndPassword: boolean;
    PostLoginByPhoneAndPassword: boolean;
    PutUpdateProfile: boolean;
    GetEmailAvailability: boolean;
    GetPhoneAvailability: boolean;
    GetUsernameAvailability: boolean;
    GetPasswordlessLoginByEmail: boolean;
    GetPasswordlessLoginByPhone: boolean;
    GetPasswordlessLoginByUsername: boolean;
  };
}
export const saveJSWidgetsOptionalCaptcha = (data: OptionalCaptcha) => {
  return {
    payload: { ...data },
    type: JSWidgetsConst.UPDATE_OPTIONAL_CAPTCHA
  };
};
export const saveJSWidgetsOptionalCaptchaLoadingAction = () => loadingAction(JSWidgetsConst.UPDATE_OPTIONAL_CAPTCHA_LOADING);

export const saveJSWidgetsOptionalCaptchaErrorAction = (error: string) => errorAction(JSWidgetsConst.UPDATE_OPTIONAL_CAPTCHA_ERROR, error);

export const saveJSWidgetsOptionalCaptchaSuccessAction = (data: any) => {
  const payload: any = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: JSWidgetsConst.UPDATE_OPTIONAL_CAPTCHA_SUCCESS,
    payload
  };
};
export interface CustomFieldSchema {
  Key: string;
  Display: string;
}
export interface GetCustomFieldSchema extends SideEffectSchema {
  Data: CustomFieldSchema[];
}

export interface RegistarationFieldSchema {
  IsMandatory?: boolean;
  Checked: boolean;
  Type: string;
  Name: string;
  Display: string;
  Rules: string;
  Options: any;
  Permission: any;
  DataSource: any;
  Parent: string;
  ParentDataSource: any;
}

export interface GetRegistarationFieldSchema extends SideEffectSchema {
  Data: RegistarationFieldSchema[];
}
export const CustomRegistrationField = {
  GET_CUSTOM_FIELD: "GET_CUSTOM_FIELD",
  GET_CUSTOM_FIELD_LOADING: "GET_CUSTOM_FIELD_LOADING",
  GET_CUSTOM_FIELD_ERROR: "GET_CUSTOM_FIELD_ERROR",
  GET_CUSTOM_FIELD_SUCCESS: "GET_CUSTOM_FIELD_SUCCESS",

  GET_REGISTRATION_FORMS_FIELD: "GET_REGISTRATION_FORMS_FIELD",
  GET_REGISTRATION_FORMS_FIELD_LOADING: "GET_REGISTRATION_FORMS_FIELD_LOADING",
  GET_REGISTRATION_FORMS_FIELD_ERROR: "GET_REGISTRATION_FORMS_FIELD_ERROR",
  GET_REGISTRATION_FORMS_FIELD_SUCCESS: "GET_REGISTRATION_FORMS_FIELD_SUCCESS",

  GET_PLATFORM_FIELD: "GET_PLATFORM_FIELD",
  GET_PLATFORM_FIELD_LOADING: "GET_PLATFORM_FIELD_LOADING",
  GET_PLATFORM_FIELD_ERROR: "GET_PLATFORM_FIELD_ERROR",
  GET_PLATFORM_FIELD_SUCCESS: "GET_PLATFORM_FIELD_SUCCESS",

  POST_PLATFORM_FIELD: "POST_PLATFORM_FIELD",
  POST_PLATFORM_FIELD_LOADING: "POST_PLATFORM_FIELD_LOADING",
  POST_PLATFORM_FIELD_ERROR: "POST_PLATFORM_FIELD_ERROR",
  POST_PLATFORM_FIELD_SUCCESS: "POST_PLATFORM_FIELD_SUCCESS",

  UPDATE_DATASCHEMA_FIELDS_DATA: "UPDATE_DATASCHEMA_FIELDS_DATA",
  UPDATE_DATASCHEMA_FIELDS_DATA_SUCCESS: "UPDATE_DATASCHEMA_FIELDS_DATA_SUCCESS"
};
// update props data
export const updatePropsDataSchemaAction = (platFormFields: any, registrationDataFields: any, customFilesds: any) => {
  return {
    payload: {
      platFormFields: platFormFields,
      registrationDataFields: registrationDataFields,
      customFilesds: customFilesds
    },
    type: CustomRegistrationField.UPDATE_DATASCHEMA_FIELDS_DATA
  };
};
export const updatePropsDataSchemaSuccessAction = (platFormFields: any, registrationDataFields: any, customFilesds: any) => {
  const payload: any = {
    platFormFields,
    registrationDataFields,
    customFilesds,
    ...successSideEffectState
  };
  return {
    type: CustomRegistrationField.UPDATE_DATASCHEMA_FIELDS_DATA_SUCCESS,
    payload
  };
};

// Custom Field
export const getCustomFieldAction = () => {
  return {
    payload: {},
    type: CustomRegistrationField.GET_CUSTOM_FIELD
  };
};
export const getCustomFieldLoadingAction = () => loadingAction(CustomRegistrationField.GET_CUSTOM_FIELD_LOADING);

export const getCustomFieldErrorAction = (error: string) => errorAction(CustomRegistrationField.GET_CUSTOM_FIELD_ERROR, error);

export const getCustomFieldSuccessAction = (data: any) => {
  const payload: any = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: CustomRegistrationField.GET_CUSTOM_FIELD_SUCCESS,
    payload
  };
};
// Registration Field
export const getRegistrationFieldAction = () => {
  return {
    payload: {},
    type: CustomRegistrationField.GET_REGISTRATION_FORMS_FIELD
  };
};
export const getRegistrationFieldLoadingAction = () => loadingAction(CustomRegistrationField.GET_REGISTRATION_FORMS_FIELD_LOADING);

export const getRegistrationFieldErrorAction = (error: string) => errorAction(CustomRegistrationField.GET_REGISTRATION_FORMS_FIELD_ERROR, error);

export const getRegistrationFieldSuccessAction = (data: any) => {
  const payload: any = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: CustomRegistrationField.GET_REGISTRATION_FORMS_FIELD_SUCCESS,
    payload
  };
};
// Post PlatForm Field
export const postPlatformFieldAction = (data: any) => {
  return {
    payload: { data },
    type: CustomRegistrationField.POST_PLATFORM_FIELD
  };
};
export const postPlatformFieldLoadingAction = () => loadingAction(CustomRegistrationField.POST_PLATFORM_FIELD_LOADING);

export const postPlatformFieldErrorAction = (error: string) => errorAction(CustomRegistrationField.POST_PLATFORM_FIELD_ERROR, error);

export const postPlatformSuccessAction = (data: any) => {
  const payload: any = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: CustomRegistrationField.POST_PLATFORM_FIELD_SUCCESS,
    payload
  };
};
// PlatForm Field
export const getPlatformFieldAction = () => {
  return {
    payload: {},
    type: CustomRegistrationField.GET_PLATFORM_FIELD
  };
};
export const getPlatformFieldLoadingAction = () => loadingAction(CustomRegistrationField.GET_PLATFORM_FIELD_LOADING);

export const getPlatformFieldErrorAction = (error: string) => errorAction(CustomRegistrationField.GET_PLATFORM_FIELD_ERROR, error);

export const getPlatformSuccessAction = (data: any) => {
  const payload: any = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: CustomRegistrationField.GET_PLATFORM_FIELD_SUCCESS,
    payload
  };
};

export enum PageType {
  Auth = 0,
  Profile = 1,
  Workflow = 2
}
export enum FileType {
  HTML = 0,
  BeforeScript = 1,
  CommonScript = 2,
  EndScript = 3,
  CustomCss = 4,
  CustomJS = 5,
  HeadTags = 6,
  FavIcon = 7,
  JQueryScript = 8,
  StyleJSON = 9
}
/**
 * EMAIL TEMPLATES
 */

/**
 * GET_ALL_EMAIL_TEMPLATES
 * This action is used to get all email templates in an Array format
 *
 * @returns {Array} Array of all email templates
 * */
export interface AllEmailTemplatesSchema extends SideEffectSchema {
  Data?: any;
}

export const getAllEmailTemplatesAction = () => {
  return {
    type: DeploymentConst.GET_ALL_EMAIL_TEMPLATES,
    payload: {}
  };
};

export const getAllEmailTemplatesLoadingAction = () => loadingAction(DeploymentConst.GET_ALL_EMAIL_TEMPLATES_LOADING);

export const getAllEmailTemplatesErrorAction = (error: string) => errorAction(DeploymentConst.GET_ALL_EMAIL_TEMPLATES_ERROR, error);

export const getAllEmailTemplatesSuccessAction = (data: AllEmailTemplatesSchema) => {
  const payload: AllEmailTemplatesSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: DeploymentConst.GET_ALL_EMAIL_TEMPLATES_SUCCESS,
    payload
  };
};

/**
 * EMAIL TEMPLATE MUTATIONS
 */
export interface EmailTemplateMutationSchema extends SideEffectSchema {
  Message?: string;
  ErrorCode?: number;
}

export const createEmailTemplateAction = (template: any) => ({
  type: DeploymentConst.CREATE_EMAIL_TEMPLATE,
  payload: { template }
});
export const createEmailTemplateLoadingAction = () => loadingAction(DeploymentConst.CREATE_EMAIL_TEMPLATE_LOADING);
export const createEmailTemplateErrorAction = (error: string) => errorAction(DeploymentConst.CREATE_EMAIL_TEMPLATE_ERROR, error);
export const createEmailTemplateSuccessAction = (data: EmailTemplateMutationSchema) => ({
  type: DeploymentConst.CREATE_EMAIL_TEMPLATE_SUCCESS,
  payload: { ...data, ...successSideEffectState }
});

export const updateEmailTemplateAction = (template: any) => ({
  type: DeploymentConst.UPDATE_EMAIL_TEMPLATE,
  payload: { template }
});
export const updateEmailTemplateLoadingAction = () => loadingAction(DeploymentConst.UPDATE_EMAIL_TEMPLATE_LOADING);
export const updateEmailTemplateErrorAction = (error: string) => errorAction(DeploymentConst.UPDATE_EMAIL_TEMPLATE_ERROR, error);
export const updateEmailTemplateSuccessAction = (data: EmailTemplateMutationSchema) => ({
  type: DeploymentConst.UPDATE_EMAIL_TEMPLATE_SUCCESS,
  payload: { ...data, ...successSideEffectState }
});

export const deleteEmailTemplateAction = (templateType: string, templateName: string) => ({
  type: DeploymentConst.DELETE_EMAIL_TEMPLATE,
  payload: { templateType, templateName }
});
export const deleteEmailTemplateLoadingAction = () => loadingAction(DeploymentConst.DELETE_EMAIL_TEMPLATE_LOADING);
export const deleteEmailTemplateErrorAction = (error: string) => errorAction(DeploymentConst.DELETE_EMAIL_TEMPLATE_ERROR, error);
export const deleteEmailTemplateSuccessAction = (data: EmailTemplateMutationSchema) => ({
  type: DeploymentConst.DELETE_EMAIL_TEMPLATE_SUCCESS,
  payload: { ...data, ...successSideEffectState }
});

export const resetEmailTemplateAction = (template: any) => ({
  type: DeploymentConst.RESET_EMAIL_TEMPLATE,
  payload: { template }
});
export const resetEmailTemplateLoadingAction = () => loadingAction(DeploymentConst.RESET_EMAIL_TEMPLATE_LOADING);
export const resetEmailTemplateErrorAction = (error: string) => errorAction(DeploymentConst.RESET_EMAIL_TEMPLATE_ERROR, error);
export const resetEmailTemplateSuccessAction = (data: EmailTemplateMutationSchema) => ({
  type: DeploymentConst.RESET_EMAIL_TEMPLATE_SUCCESS,
  payload: { ...data, ...successSideEffectState }
});
export const resetEmailTemplateMutationAction = () => ({
  type: DeploymentConst.RESET_EMAIL_TEMPLATE_MUTATION_STATE,
  payload: {}
});

export const setDefaultEmailTemplateAction = (template: any) => ({
  type: DeploymentConst.SET_DEFAULT_EMAIL_TEMPLATE,
  payload: { template }
});
export const setDefaultEmailTemplateLoadingAction = () => loadingAction(DeploymentConst.SET_DEFAULT_EMAIL_TEMPLATE_LOADING);
export const setDefaultEmailTemplateErrorAction = (error: string) => errorAction(DeploymentConst.SET_DEFAULT_EMAIL_TEMPLATE_ERROR, error);
export const setDefaultEmailTemplateSuccessAction = (data: EmailTemplateMutationSchema) => ({
  type: DeploymentConst.SET_DEFAULT_EMAIL_TEMPLATE_SUCCESS,
  payload: { ...data, ...successSideEffectState }
});

/**
 * EMAIL TEMPLATE SETTINGS
 */
export interface EmailTemplateSettingsSchema extends SideEffectSchema {
  Data?: any;
  errorCode?: number;
  ErrorMessage?: string;
}
export const getEmailSettingsAction = () => ({
  type: DeploymentConst.GET_EMAIL_SETTINGS,
  payload: {}
});
export const getEmailSettingsLoadingAction = () => loadingAction(DeploymentConst.GET_EMAIL_SETTINGS_LOADING);
export const getEmailSettingsErrorAction = (error: string) => errorAction(DeploymentConst.GET_EMAIL_SETTINGS_ERROR, error);
export const getEmailSettingsSuccessAction = (data: EmailTemplateSettingsSchema) => ({
  type: DeploymentConst.GET_EMAIL_SETTINGS_SUCCESS,
  payload: { ...data, ...successSideEffectState }
});

export interface SaveEmailSettingsPayload {
  settings: any;
  templateUpdate?: {
    subject: string;
    body: string;
    templatetype: string;
  };
}

export const saveEmailSettingsAction = (payload: SaveEmailSettingsPayload) => ({
  type: DeploymentConst.SAVE_EMAIL_SETTINGS,
  payload
});
export const saveEmailSettingsLoadingAction = () => loadingAction(DeploymentConst.SAVE_EMAIL_SETTINGS_LOADING);
export const saveEmailSettingsErrorAction = (error: string) => errorAction(DeploymentConst.SAVE_EMAIL_SETTINGS_ERROR, error);
export const saveEmailSettingsSuccessAction = (data: EmailTemplateSettingsSchema) => ({
  type: DeploymentConst.SAVE_EMAIL_SETTINGS_SUCCESS,
  payload: { ...data, ...successSideEffectState }
});
export const resetSaveEmailSettingsAction = () => ({
  type: DeploymentConst.RESET_SAVE_EMAIL_SETTINGS_STATE,
  payload: {}
});

/**
 * SEND TEST EMAIL
 */
// export interface SendTestEmailPayload {
//   mailObject: any;
// }
// export const sendTestEmailAction = (payload: SendTestEmailPayload) => ({
//   type: DeploymentConst.SEND_TEST_EMAIL_TEMPLATE,
//   payload
// });
// export const sendTestEmailLoadingAction = () => loadingAction(DeploymentConst.SEND_TEST_EMAIL_TEMPLATE_LOADING);
// export const sendTestEmailErrorAction = (error: string) => errorAction(DeploymentConst.SEND_TEST_EMAIL_TEMPLATE_ERROR, error);
// export const sendTestEmailSuccessAction = (data: SideEffectSchema) => ({
//   type: DeploymentConst.SEND_TEST_EMAIL_TEMPLATE_SUCCESS,
//   payload: { ...data, ...successSideEffectState }
// });
// export const resetSendTestEmailAction = () => ({
//   type: DeploymentConst.RESET_SEND_TEST_EMAIL_STATE,
//   payload: {}
// });

/**
 * AI EMAIL TEMPLATE GENERATION
 */
export interface GenerateEmailTemplateAISchema extends SideEffectSchema {
  emailHtmlCode?: string;
  subjectLine?: string;
  errorCode?: number;
  message?: string;
}
export interface GenerateEmailTemplateAIPayload {
  prompt: string;
  templateType: string;
  tokenType?: string;
  inferredTokenType?: string;
  templateStyling?: string;
  templateName?: string;
}
export const generateEmailTemplateAIAction = (payload: GenerateEmailTemplateAIPayload) => ({
  type: DeploymentConst.GENERATE_EMAIL_TEMPLATE_AI,
  payload
});
export const generateEmailTemplateAILoadingAction = () => loadingAction(DeploymentConst.GENERATE_EMAIL_TEMPLATE_AI_LOADING);
export const generateEmailTemplateAIErrorAction = (error: string) => errorAction(DeploymentConst.GENERATE_EMAIL_TEMPLATE_AI_ERROR, error);
export const generateEmailTemplateAISuccessAction = (data: GenerateEmailTemplateAISchema) => ({
  type: DeploymentConst.GENERATE_EMAIL_TEMPLATE_AI_SUCCESS,
  payload: { ...data, ...successSideEffectState }
});
export const resetGenerateEmailTemplateAIAction = () => ({
  type: DeploymentConst.RESET_GENERATE_EMAIL_TEMPLATE_AI_STATE,
  payload: {}
});
